import { helpers } from '@vuelidate/validators';
import { ValidationRule } from '@vuelidate/core';

export const valueSelected = (defaultVal = 'Select one', valueKey = ''): ValidationRule => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return helpers.withParams({ type: 'required' }, (value: any): boolean => {
		if (valueKey) {
			return value[valueKey] !== defaultVal;
		} else {
			return value !== defaultVal;
		}
	});
};
